
export const LEGACY_CLIENT_RIGHTS = [
    {
        'name': 'user-roles',
        'i18nKey': 'ADMIN.ENTITIES.USERROLES',
        'title': 'Users Roles',
        'description': 'Rights relating to user role management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the user roles in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete user roles',
            },
        ],
    },
    {
        'name': 'users',
        'i18nKey': 'ADMIN.ENTITIES.USERS',
        'title': 'Users',
        'description': 'Rights relating to user management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the users in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete users',
            },
        ],
    },
    {
        'name': 'access-groups',
        'i18nKey': 'ADMIN.ENTITIES.COSTCENTRES',
        'title': 'Cost Centres',
        'description': 'Rights relating to cost centre management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete cost centres',
            },
        ],
    },
    {
        'name': 'asset-categories',
        'i18nKey': 'ADMIN.ENTITIES.ASSET_CATEGORIES',
        'title': 'Asset Categories',
        'description': 'Rights relating to asset category management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete asset categories',
            },
        ],
    },
    {
        'name': 'assets-groups',
        'i18nKey': 'ADMIN.ENTITIES.ASSETGROUPS',
        'title': 'Asset Groups',
        'description': 'Rights relating to asset group management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete asset groups',
            },
        ],
    },
    {
        'name': 'assets',
        'i18nKey': 'ADMIN.ENTITIES.ASSETS',
        'title': 'Assets',
        'description': 'Rights relating to asset management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the assets in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete assets',
            },
        ],
    },
    {
        'name': 'devices',
        'i18nKey': 'ADMIN.ENTITIES.DEVICES',
        'title': 'Devices',
        'description': 'Rights relating to device management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the devices in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete devices',
            },
            {
                'title': 'Poll',
                'name': 'poll',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.POLL',
                'description': 'Poll devices for telemetry updates',
            },
            {
                'title': 'Toggle Outputs',
                'name': 'outputs',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.OUTPUTS',
                'description': 'Toggle device outputs',
            },
            {
                'title': 'Upload Parameters',
                'name': 'setparams',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.SETPARAMS',
                'description': 'Upload parameters to devices',
            },
        ],
    },
    {
        'name': 'simcards',
        'i18nKey': 'ADMIN.ENTITIES.SIMCARDS',
        'title': 'SIM Cards',
        'description': 'Rights relating to SIM card management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the SIM cards in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete SIM cards',
            },
        ],
    },
    {
        'name': 'fuelcards',
        'i18nKey': 'ADMIN.ENTITIES.FUELCARDS',
        'title': 'Fuel Cards',
        'description': 'Rights relating to fuel card management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the fuel cards in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete fuel cards',
            },
        ],
    },
    {
        'name': 'deviceProviders',
        'i18nKey': 'ADMIN.ENTITIES.DEVICEPROVIDERS',
        'title': 'Device Providers',
        'description': 'Rights relating to device provider management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the device providers in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete device providers',
            },
        ],
    },
    {
        'name': 'smsGatewayProviders',
        'i18nKey': 'ADMIN.ENTITIES.SMSGATEWAYPROVIDERS',
        'title': 'SMS Gateways',
        'description': 'Rights relating to SMS gateway management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the SMS gateways in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete SMS gateways',
            },
        ],
    },
    {
        'name': 'emailProviders',
        'i18nKey': 'ADMIN.ENTITIES.EMAILPROVIDERS',
        'title': 'Email Providers',
        'description': 'Rights relating to email provider management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the email providers in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete email providers',
            },
        ],
    },
    {
        'name': 'zones',
        'i18nKey': 'ADMIN.ENTITIES.ZONES',
        'title': 'Geofences',
        'description': 'Rights relating to geofence management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the geofences in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete geofences and their groups',
            },
        ],
    },
    {
        'name': 'alerts',
        'i18nKey': 'ADMIN.ENTITIES.ALERTS',
        'title': 'Alerts',
        'description': 'Rights relating to alert management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the alerts in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete alert definitions',
            },
        ],
    },
    {
        'name': 'media',
        'i18nKey': 'ADMIN.ENTITIES.MEDIA',
        'title': 'Media',
        'description': 'Rights relating to viewing and generating media events',
        'rights': [
            {
                'title': 'View',
                'name': 'view',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.VIEW',
                'description': 'View and list videos and images',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create media requests',
            },
            {
                'title': 'Update',
                'name': 'update',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.UPDATE',
                'description': 'Modify media requests',
            },
            {
                'title': 'Delete',
                'name': 'delete',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.DELETE',
                'description': 'Delete recorded media files',
            },
        ],
    },
    {
        'name': 'analytics',
        'i18nKey': 'ADMIN.ENTITIES.ANALYTICS_REPORTS',
        'title': 'Analytics',
        'description': 'Rights relating to analytics reports',
        'rights': [
            {
                'title': 'View',
                'name': 'view',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.VIEW',
                'description': 'View analytics reports',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete analytics reports',
            },
        ],
    },
    {
        'name': 'reports',
        'i18nKey': 'ADMIN.ENTITIES.REPORTS',
        'title': 'Reports',
        'description': 'Rights relating to reports',
        'rights': [
            {
                'title': 'Run',
                'name': 'run',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.RUN',
                'description': 'Run reports on demand.',
            },
            {
                'title': 'Schedule',
                'name': 'schedule',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.SCHEDULE',
                'description': 'Create, modify and delete scheduled reports',
            },
            {
                'title': 'Templates',
                'name': 'templates',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.TEMPLATES',
                'description': 'Create, modify and delete report templates',
            },
        ],
    },
    {
        'name': 'customFields',
        'i18nKey': 'ADMIN.ENTITIES.CUSTOMFIELDS',
        'title': 'Custom Fields',
        'description': 'Rights relating to custom fields',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete custom fields.',
            },
        ],
    },
];


export const LEGACY_VENDOR_RIGHTS = [
    {
        'name': 'clients',
        'i18nKey': 'ADMIN.ENTITIES.CLIENTS',
        'title': 'Clients',
        'description': 'Rights relating to client management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the clients in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete clients',
            },
            {
                'title': 'List Users',
                'name': 'list-users',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_USERS',
                'description': 'List client users and user roles',
            },
            {
                'title': 'Modify Users',
                'name': 'users',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.USERS',
                'description': 'Create, modify and delete client users and their roles',
            },
            {
                'title': 'List Assets',
                'name': 'list-assets',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_ASSETS',
                'description': 'List client assets',
            },
            {
                'title': 'Modify Assets',
                'name': 'assets',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.ASSETS',
                'description': 'Create, modify and delete assets and their groups',
            },
            {
                'title': 'List Devices',
                'name': 'list-devices',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_DEVICES',
                'description': 'List client devices',
            },
            {
                'title': 'Modify Devices',
                'name': 'devices',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.DEVICES',
                'description': 'Create, modify and delete devices',
            },
            {
                'title': 'List SIM Cards',
                'name': 'list-simcards',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_SIMCARDS',
                'description': 'List SIM cards',
            },
            {
                'title': 'Modify SIM Cards',
                'name': 'simcards',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.SIMCARDS',
                'description': 'Create, modify and delete SIM cards',
            },
            {
                'title': 'List Fuel Cards',
                'name': 'list-fuelcards',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_FUELCARDS',
                'description': 'List fuel cards',
            },
            {
                'title': 'Modify Fuel Cards',
                'name': 'fuelcards',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.FUELCARDS',
                'description': 'Create, modify and delete fuel cards',
            },
            {
                'title': 'List Device Providers',
                'name': 'list-deviceProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_DEVICEPROVIDERS',
                'description': 'List client device providers',
            },
            {
                'title': 'Modify Device Providers',
                'name': 'deviceProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.DEVICEPROVIDERS',
                'description': 'Create, modify and delete device providers',
            },
            {
                'title': 'List SMS Gateways',
                'name': 'list-smsGatewayProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_SMSGATEWAYPROVIDERS',
                'description': 'List client SMS gateways',
            },
            {
                'title': 'Modify SMS Gateways',
                'name': 'smsGatewayProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.SMSGATEWAYPROVIDERS',
                'description': 'Create, modify and delete SMS gateways',
            },
            {
                'title': 'List Email Providers',
                'name': 'list-emailProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_EMAILPROVIDERS',
                'description': 'List client email providers',
            },
            {
                'title': 'Modify Email Providers',
                'name': 'emailProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.EMAILPROVIDERS',
                'description': 'Create, modify and delete email providers',
            },
            {
                'title': 'List Geofences',
                'name': 'list-zones',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_ZONES',
                'description': 'List client geofences',
            },
            {
                'title': 'Modify Geofences',
                'name': 'zones',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.ZONES',
                'description': 'Create, modify and delete geofences and their groups',
            },
            {
                'title': 'View Media',
                'name': 'list-media',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_MEDIA',
                'description': 'View client media',
            },
            {
                'title': 'Modify Media',
                'name': 'media',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.MEDIA',
                'description': 'Request media and update media events',
            },
            {
                'title': 'Modify Alerts',
                'name': 'alerts',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.ALERTS',
                'description': 'Create, modify and delete alert definitions',
            },
            {
                'title': 'Poll',
                'name': 'poll',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.POLL',
                'description': 'Poll devices for telemetry updates',
            },
            {
                'title': 'Upload Parameters',
                'name': 'setparams',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.SETPARAMS',
                'description': 'Upload parameters to devices',
            },
            {
                'title': 'Toggle Outputs',
                'name': 'outputs',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.OUTPUTS',
                'description': 'Toggle device outputs',
            },
            {
                'title': 'Run Reports',
                'name': 'reports',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.REPORTS',
                'description': 'Run and schedule reports',
            },
            {
                'title': 'Modify Report Templates',
                'name': 'report-templates',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.REPORT_TEMPLATES',
                'description': 'Create, modify and delete report templates',
            },
            {
                'title': 'Custom Fields',
                'name': 'customFields',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CUSTOMFIELDS',
                'description': 'Create, modify and delete custom fields',
            },
            {
                'title': 'Analytics Reports',
                'name': 'analytics',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.ANALYTICS',
                'description': 'Create, modify and delete analytics reports',
            },
        ],
    },
    {
        'name': 'user-roles',
        'i18nKey': 'ADMIN.ENTITIES.USERROLES',
        'title': 'Users Roles',
        'description': 'Rights relating to user role management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the user roles in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete user roles',
            },
        ],
    },
    {
        'name': 'users',
        'i18nKey': 'ADMIN.ENTITIES.USERS',
        'title': 'Users',
        'description': 'Rights relating to user management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the users in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete users',
            },
        ],
    },
    {
        'name': 'themes',
        'i18nKey': 'ADMIN.ENTITIES.THEMES',
        'title': 'Themes',
        'description': 'Rights relating to theme management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete themes',
            },
        ],
    },
    {
        'name': 'mapSets',
        'i18nKey': 'ADMIN.ENTITIES.MAPSETS',
        'title': 'Map Sets',
        'description': 'Rights relating to map set management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete map sets',
            },
        ],
    },
    {
        'i18nKey': 'ADMIN.ENTITIES.BILLING',
        'name': 'billing',
        'title': 'Billing',
        'description': 'Rights relating to billing profiles',
        'rights': [
            {
                'title': 'Create Profiles',
                'name': 'createProfile',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATEPROFILE',
                'description': 'Create, modify and delete billing profiles',
            },
        ],
    },
];

export const LEGACY_DISTRIBUTOR_RIGHTS = [
    {
        'name': 'vendors',
        'i18nKey': 'ADMIN.ENTITIES.VENDORS',
        'title': 'Vendors',
        'description': 'Rights relating to vendor management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the vendors in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete vendors',
            },
            {
                'title': 'Migrate',
                'name': 'migrate',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.MIGRATE',
                'description': 'Migrate vendors between distributors',
            },
            {
                'title': 'List Users',
                'name': 'list-users',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_USERS',
                'description': 'List vendor users and user roles',
            },
            {
                'title': 'Modify Users',
                'name': 'users',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.USERS',
                'description': 'Create, modify and delete vendor users',
            },
        ],
    },
    {
        'name': 'clients',
        'i18nKey': 'ADMIN.ENTITIES.CLIENTS',
        'title': 'Clients',
        'description': 'Rights relating to client management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the clients in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete clients',
            },
            {
                'title': 'List Users',
                'name': 'list-users',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_USERS',
                'description': 'List client users and user roles',
            },
            {
                'title': 'Modify Users',
                'name': 'users',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.USERS',
                'description': 'Create, modify and delete client users and their roles',
            },
            {
                'title': 'List Assets',
                'name': 'list-assets',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_ASSETS',
                'description': 'List client assets',
            },
            {
                'title': 'Modify Assets',
                'name': 'assets',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.ASSETS',
                'description': 'Create, modify and delete assets and their groups',
            },
            {
                'title': 'List Devices',
                'name': 'list-devices',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_DEVICES',
                'description': 'List client devices',
            },
            {
                'title': 'Modify Devices',
                'name': 'devices',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.DEVICES',
                'description': 'Create, modify and delete devices',
            },
            {
                'title': 'List SIM Cards',
                'name': 'list-simcards',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_SIMCARDS',
                'description': 'List SIM cards',
            },
            {
                'title': 'Modify SIM Cards',
                'name': 'simcards',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.SIMCARDS',
                'description': 'Create, modify and delete SIM cards',
            },
            {
                'title': 'List Fuel Cards',
                'name': 'list-fuelcards',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_FUELCARDS',
                'description': 'List fuel cards',
            },
            {
                'title': 'Modify Fuel Cards',
                'name': 'fuelcards',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.FUELCARDS',
                'description': 'Create, modify and delete fuel cards',
            },
            {
                'title': 'List Device Providers',
                'name': 'list-deviceProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_DEVICEPROVIDERS',
                'description': 'List client device providers',
            },
            {
                'title': 'Modify Device Providers',
                'name': 'deviceProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.DEVICEPROVIDERS',
                'description': 'Create, modify and delete device providers',
            },
            {
                'title': 'List SMS Gateways',
                'name': 'list-smsGatewayProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_SMSGATEWAYPROVIDERS',
                'description': 'List client SMS gateways',
            },
            {
                'title': 'Modify SMS Gateways',
                'name': 'smsGatewayProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.SMSGATEWAYPROVIDERS',
                'description': 'Create, modify and delete SMS gateways',
            },
            {
                'title': 'List Email Providers',
                'name': 'list-emailProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_EMAILPROVIDERS',
                'description': 'List client email providers',
            },
            {
                'title': 'Modify Email Providers',
                'name': 'emailProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.EMAILPROVIDERS',
                'description': 'Create, modify and delete email providers',
            },
            {
                'title': 'List Geofences',
                'name': 'list-zones',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_ZONES',
                'description': 'List client geofences',
            },
            {
                'title': 'Modify Geofences',
                'name': 'zones',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.ZONES',
                'description': 'Create, modify and delete geofences and their groups',
            },
            {
                'title': 'View Media',
                'name': 'list-media',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_MEDIA',
                'description': 'View client media',
            },
            {
                'title': 'Modify Media',
                'name': 'media',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.MEDIA',
                'description': 'Request media and update media events',
            },
            {
                'title': 'Modify Alerts',
                'name': 'alerts',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.ALERTS',
                'description': 'Create, modify and delete alert definitions',
            },
            {
                'title': 'Poll',
                'name': 'poll',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.POLL',
                'description': 'Poll devices for telemetry updates',
            },
            {
                'title': 'Upload Parameters',
                'name': 'setparams',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.SETPARAMS',
                'description': 'Upload parameters to devices',
            },
            {
                'title': 'Toggle Outputs',
                'name': 'outputs',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.OUTPUTS',
                'description': 'Toggle device outputs',
            },
            {
                'title': 'Run Reports',
                'name': 'reports',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.REPORTS',
                'description': 'Run and schedule reports',
            },
            {
                'title': 'Modify Report Templates',
                'name': 'report-templates',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.REPORT_TEMPLATES',
                'description': 'Create, modify and delete report templates',
            },
            {
                'title': 'Custom Fields',
                'name': 'customFields',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CUSTOMFIELDS',
                'description': 'Create, modify and delete custom fields',
            },
            {
                'title': 'Analytics Reports',
                'name': 'analytics',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.ANALYTICS',
                'description': 'Create, modify and delete analytics reports',
            },
        ],
    },
    {
        'name': 'user-roles',
        'i18nKey': 'ADMIN.ENTITIES.USERROLES',
        'title': 'Users Roles',
        'description': 'Rights relating to user role management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the user roles in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete user roles',
            },
        ],
    },
    {
        'name': 'users',
        'i18nKey': 'ADMIN.ENTITIES.USERS',
        'title': 'Users',
        'description': 'Rights relating to user management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the users in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete users',
            },
        ],
    },
    {
        'name': 'themes',
        'i18nKey': 'ADMIN.ENTITIES.THEMES',
        'title': 'Themes',
        'description': 'Rights relating to theme management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete themes',
            },
        ],
    },
    {
        'name': 'mapSets',
        'i18nKey': 'ADMIN.ENTITIES.MAPSETS',
        'title': 'Map Sets',
        'description': 'Rights relating to map set management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete map sets',
            },
        ],
    },
    {
        'i18nKey': 'ADMIN.ENTITIES.BILLING',
        'name': 'billing',
        'title': 'Billing',
        'description': 'Rights relating to billing profiles',
        'rights': [
            {
                'title': 'Create Profiles',
                'name': 'createProfile',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATEPROFILE',
                'description': 'Create, modify and delete billing profiles',
            },
        ],
    },
];

export const LEGACY_SYSTEM_RIGHTS = [
    {
        'name': 'system',
        'i18nKey': 'ADMIN.ENTITIES.SYSTEM',
        'title': 'System',
        'description': 'Rights relating to system management',
        'rights': [
            {
                'title': 'Global Lookups',
                'name': 'global-lookups',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.GLOBAL_LOOKUPS',
                'description': 'Create, modify and delete global lookups',
            },
        ],
    },
    {
        'name': 'distributors',
        'i18nKey': 'ADMIN.ENTITIES.DISTRIBUTORS',
        'title': 'Distributors',
        'description': 'Rights relating to distributor management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the distributors in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete distributors',
            },
            {
                'title': 'List Users',
                'name': 'list-users',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_USERS',
                'description': 'List distributor users and user roles',
            },
            {
                'title': 'Modify Users',
                'name': 'users',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.USERS',
                'description': 'Create, modify and delete distributor users',
            },
        ],
    },
    {
        'name': 'vendors',
        'i18nKey': 'ADMIN.ENTITIES.VENDORS',
        'title': 'Vendors',
        'description': 'Rights relating to vendor management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the vendors in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete vendors',
            },
            {
                'title': 'Migrate',
                'name': 'migrate',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.MIGRATE',
                'description': 'Migrate vendors between distributors',
            },
            {
                'title': 'List Users',
                'name': 'list-users',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_USERS',
                'description': 'List vendor users and user roles',
            },
            {
                'title': 'Modify Users',
                'name': 'users',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.USERS',
                'description': 'Create, modify and delete vendor users',
            },
        ],
    },
    {
        'name': 'clients',
        'i18nKey': 'ADMIN.ENTITIES.CLIENTS',
        'title': 'Clients',
        'description': 'Rights relating to client management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the clients in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete clients',
            },
            {
                'title': 'List Users',
                'name': 'list-users',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_USERS',
                'description': 'List client users and user roles',
            },
            {
                'title': 'Modify Users',
                'name': 'users',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.USERS',
                'description': 'Create, modify and delete client users and their roles',
            },
            {
                'title': 'List Assets',
                'name': 'list-assets',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_ASSETS',
                'description': 'List client assets',
            },
            {
                'title': 'Modify Assets',
                'name': 'assets',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.ASSETS',
                'description': 'Create, modify and delete assets and their groups',
            },
            {
                'title': 'List Devices',
                'name': 'list-devices',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_DEVICES',
                'description': 'List client devices',
            },
            {
                'title': 'Modify Devices',
                'name': 'devices',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.DEVICES',
                'description': 'Create, modify and delete devices',
            },
            {
                'title': 'List SIM Cards',
                'name': 'list-simcards',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_SIMCARDS',
                'description': 'List SIM cards',
            },
            {
                'title': 'Modify SIM Cards',
                'name': 'simcards',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.SIMCARDS',
                'description': 'Create, modify and delete SIM cards',
            },
            {
                'title': 'List Fuel Cards',
                'name': 'list-fuelcards',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_FUELCARDS',
                'description': 'List fuel cards',
            },
            {
                'title': 'Modify Fuel Cards',
                'name': 'fuelcards',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.FUELCARDS',
                'description': 'Create, modify and delete fuel cards',
            },
            {
                'title': 'List Device Providers',
                'name': 'list-deviceProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_DEVICEPROVIDERS',
                'description': 'List client device providers',
            },
            {
                'title': 'Modify Device Providers',
                'name': 'deviceProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.DEVICEPROVIDERS',
                'description': 'Create, modify and delete device providers',
            },
            {
                'title': 'List SMS Gateways',
                'name': 'list-smsGatewayProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_SMSGATEWAYPROVIDERS',
                'description': 'List client SMS gateways',
            },
            {
                'title': 'Modify SMS Gateways',
                'name': 'smsGatewayProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.SMSGATEWAYPROVIDERS',
                'description': 'Create, modify and delete SMS gateways',
            },
            {
                'title': 'List Email Providers',
                'name': 'list-emailProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_EMAILPROVIDERS',
                'description': 'List client email providers',
            },
            {
                'title': 'Modify Email Providers',
                'name': 'emailProviders',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.EMAILPROVIDERS',
                'description': 'Create, modify and delete email providers',
            },
            {
                'title': 'List Geofences',
                'name': 'list-zones',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_ZONES',
                'description': 'List client geofences',
            },
            {
                'title': 'Modify Geofences',
                'name': 'zones',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.ZONES',
                'description': 'Create, modify and delete geofences and their groups',
            },
            {
                'title': 'View Media',
                'name': 'list-media',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST_MEDIA',
                'description': 'View client media',
            },
            {
                'title': 'Modify Media',
                'name': 'media',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.MEDIA',
                'description': 'Request media and update media events',
            },
            {
                'title': 'Modify Alerts',
                'name': 'alerts',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.ALERTS',
                'description': 'Create, modify and delete alert definitions',
            },
            {
                'title': 'Poll',
                'name': 'poll',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.POLL',
                'description': 'Poll devices for telemetry updates',
            },
            {
                'title': 'Upload Parameters',
                'name': 'setparams',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.SETPARAMS',
                'description': 'Upload parameters to devices',
            },
            {
                'title': 'Toggle Outputs',
                'name': 'outputs',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.OUTPUTS',
                'description': 'Toggle device outputs',
            },
            {
                'title': 'Run Reports',
                'name': 'reports',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.REPORTS',
                'description': 'Run and schedule reports',
            },
            {
                'title': 'Modify Report Templates',
                'name': 'report-templates',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.REPORT_TEMPLATES',
                'description': 'Create, modify and delete report templates',
            },
            {
                'title': 'Custom Fields',
                'name': 'customFields',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CUSTOMFIELDS',
                'description': 'Create, modify and delete custom fields',
            },
            {
                'title': 'Analytics Reports',
                'name': 'analytics',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.ANALYTICS',
                'description': 'Create, modify and delete analytics reports',
            },
        ],
    },
    {
        'name': 'user-roles',
        'i18nKey': 'ADMIN.ENTITIES.USERROLES',
        'title': 'Users Roles',
        'description': 'Rights relating to user role management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the user roles in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete user roles',
            },
        ],
    },
    {
        'name': 'users',
        'i18nKey': 'ADMIN.ENTITIES.USERS',
        'title': 'Users',
        'description': 'Rights relating to user management',
        'rights': [
            {
                'title': 'List',
                'name': 'list',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.LIST',
                'description': 'List the users in the system',
            },
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete users',
            },
        ],
    },
    {
        'name': 'themes',
        'i18nKey': 'ADMIN.ENTITIES.THEMES',
        'title': 'Themes',
        'description': 'Rights relating to theme management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete themes',
            },
        ],
    },
    {
        'name': 'mapSets',
        'i18nKey': 'ADMIN.ENTITIES.MAPSETS',
        'title': 'Map Sets',
        'description': 'Rights relating to map set management',
        'rights': [
            {
                'title': 'Create',
                'name': 'create',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATE',
                'description': 'Create, modify and delete map sets',
            },
        ],
    },
    {
        'i18nKey': 'ADMIN.ENTITIES.BILLING',
        'name': 'billing',
        'title': 'Billing',
        'description': 'Rights relating to billing profiles',
        'rights': [
            {
                'title': 'Create Profiles',
                'name': 'createProfile',
                'i18nKey': 'ADMIN.ENTITIES.USER_ROLES.RIGHTS.CREATEPROFILE',
                'description': 'Create, modify and delete billing profiles',
            },
        ],
    },
];

export const LEGACY_RIGHTS = {
    system: LEGACY_SYSTEM_RIGHTS,
    distributor: LEGACY_DISTRIBUTOR_RIGHTS,
    vendor: LEGACY_VENDOR_RIGHTS,
    client: LEGACY_CLIENT_RIGHTS,
};
